import React, { Fragment } from 'react'

// Components
import { Answer } from './Answer';
import { ComplementaryFields } from '../ComplementaryFields';

// Interfaces
import { QuestionType, Answer as QuestionAnswer, ComplementaryAnswer } from '../../interfaces/Question';
import { useTranslation } from '../../translations/useTranslation';


interface Props {
    name: string
    answers: QuestionAnswer[] | null
    givenAnswer: string | null
    complementaryAnswers: ComplementaryAnswer | undefined
    type: QuestionType
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    onComplementaryChange: (answers: Record<string, string>) => void
}

export const Answers: React.FC<Props> = ({ answers, type, name, givenAnswer, complementaryAnswers, onChange, onComplementaryChange }) => {

    const { t } = useTranslation()

    switch(type) {

        case 'radio': {
            return (
                <div className="membership-app__choices membership-app__choices--radio">
                    {Array.isArray(answers) ? 
                        answers.map((answer) => {

                            const displayComplementaryFields = answer.value == givenAnswer;

                            return (
                                <Fragment key={answer.value}>
                                    <Answer
                                        label={t(answer.title)}
                                        radioButtonValue={answer.value}
                                        radioButtonTooltipTranslationKey={answer.tooltipTranslationKey}
                                        type={type}
                                        name={name}
                                        value={givenAnswer}
                                        onChange={onChange} />

                                    {typeof answer.complementaryFields !== 'undefined' && displayComplementaryFields && (
                                        <ComplementaryFields
                                            answersFields={complementaryAnswers}
                                            fields={answer.complementaryFields}
                                            onChange={onComplementaryChange} />
                                    )}
                                </Fragment>
                            )
                        }) : null
                    }
                </div>
            )
        }

        case 'text-input': {
            return (
                <div className="membership-app__choices membership-app__choices--text">
                    <Answer 
                        label={''} 
                        type={'text'} 
                        name={name} 
                        value={givenAnswer} 
                        onChange={onChange} />
                </div>
            )
        }
        
        default:
            return null;
    }


}